import { useCallback, useEffect, useState } from 'react';
import { getUnreadNotificationCount } from '../../../utils/api';

/**
 * Unread notification count for `email`: loads on mount, every 60s while the
 * tab is visible, and shortly after the tab becomes visible again.
 */
export function useUnreadNotifications(email) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!email) return;
    try {
      setCount(await getUnreadNotificationCount(email));
    } catch (error) {
      console.error('Error loading unread notification count:', error);
    }
  }, [email]);

  useEffect(() => {
    if (!email) return undefined;
    refresh();
    const interval = setInterval(() => {
      if (document.visibilityState === 'visible') refresh();
    }, 60000);
    let timeout;
    const onVisible = () => {
      if (document.visibilityState === 'visible') timeout = setTimeout(refresh, 1000);
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [email, refresh]);

  return { count, refresh };
}

export default useUnreadNotifications;
